import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import { 
  ADD_ALL_VARIANT_PRICING, ADD_NEW_CAR_VARIANT, DELETE_ALL_CAR_VARIANT, 
  DELETE_CAR_VARIANT, DELETE_CAR_VARIANT_PRICING, GET_CAR_VARIANTS, 
  GET_CAR_VARIANT_PRICING, GET_COUNTRIES_LIST, GET_COUNTRIES_LIST_SUCCESS, 
  UPDATE_CAR_VARIANT, GET_CAR_VARIANTS_PAGINATED, LOAD_MORE_CAR_VARIANTS,
  SEARCH_CAR_VARIANTS, SEARCH_CAR_VARIANTS_ALL
} from "./actionTypes"
import { 
  addCarModelByBrand, addCarVariant, deleteCarVariantData, fetchCarModelByBrand, 
  getCarVariantsList, getCarVariantsListPaginated, updateCarVariantData, 
  getCarVariantPricingList, deleteCarVariantPricingList,
  searchCarVariants as searchCarVariantsApi, searchCarVariantsAll as searchCarVariantsAllApi
} from "helpers/automobile_helper_apis"
import { 
  addCarVariantFail, addCarVariantSuccess, addVariantDataError, addVariantDataSuccess, 
  deleteAllCarVariantsFail, deleteAllCarVariantsSuccess, deleteCarVariantFail, 
  deleteCarVariantPricingFail, deleteCarVariantPricingSuccess, deleteCarVariantSuccess, 
  getCarVariantPricingFail, getCarVariantPricingSuccess, getCarVariantsFail, 
  getCarVariantsSuccess, getCountriesListError, getCountriesListSuccess, 
  updateCarVariantFail, updateCarVariantSuccess, getCarVariantsPaginatedSuccess, 
  getCarVariantsPaginatedFail, loadMoreCarVariantsSuccess, loadMoreCarVariantsFail,
  searchCarVariantsSuccess, searchCarVariantsFail,
  searchCarVariantsAllSuccess, searchCarVariantsAllFail
} from "./actions"
import { showToastError, showToastSuccess } from "helpers/toastBuilder"


function* fetchCarVariants() {
  try {
    const response = yield call(getCarVariantsList)
    yield put(getCarVariantsSuccess(response.data.carVariantList))
  } catch (error) {
    yield put(getCarVariantsFail(error))
    showToastError('Sorry! Failed to Fetch Variants, plese try again', 'Error');
  }
}

function* onAddCarVariant({ payload: {id , data, history } }) {
  try {
    const response = yield call(addCarVariant, id, data)
    yield put(addCarVariantSuccess(response.data));
    showToastSuccess("Variant added successfully", "SUCCESS");
    history('/car-variants');
  } catch (error) {
    yield put(addCarVariantFail(error));
    showToastError('Sorry! Failed to Add Variant, plese try again', 'Error');
  }
}

function* onUpdateCarVariant({ payload: { carvariantid, carModelId, data, history } }) {
  try {
    console.log("datatest ", data);
    const response = yield call(updateCarVariantData, carvariantid, carModelId, data );
    yield put(updateCarVariantSuccess(response?.data))
    showToastSuccess("Variant updated successfully", "SUCCESS");
    history('/car-variants'); 
  } catch (error) {
    yield put(updateCarVariantFail(error))
    showToastError('Sorry! Failed to Update Variant, plese try again', 'Error');
  }
}

function* onDeleteCarVariant({ payload: carModel  }) {
  try {
    const response = yield call(deleteCarVariantData, carModel._id );
    showToastSuccess("Variant deleted successfully", "SUCCESS");
    yield put(deleteCarVariantSuccess(carModel))
  } catch (error) {
    yield put(deleteCarVariantFail(error))
    showToastError('Sorry! Failed to delete Variant, plese try again', 'Error');
  }
}

function* onDeleteAllCarVariant() {
    try {
      const response = yield call(deleteAllCarModels)
      yield put(deleteAllCarVariantsSuccess(response))
      showToastSuccess("Variant Pricing updated successfully", "SUCCESS");
    } catch (error) {
      yield put(deleteAllCarVariantsFail(error))
      showToastError('Sorry! Failed to delete Variant, plese try again', 'Error');
    }
  }

  function* fetchModelByBrand({ payload: { id } }) {
    try {
      const response = yield call(fetchCarModelByBrand, id);
      yield put(getCountriesListSuccess(response.data.carModelsList));
    }catch(error) {
      yield put(getCountriesListError(error));
    }
  }

  function* onAddAllVariantPricing({ payload: { id, data, toggle } }) {
    try {
      const response = yield call(addCarModelByBrand, id, data);
      yield put(addVariantDataSuccess(response.data.carModelsList));
      toggle();
      showToastSuccess("Variant Pricing added successfully","Success");
    }catch(error) {
      yield put(addVariantDataError(error));
      showToastError('Vsriant Pricing Failed to add, plese try again', 'Error');
    }
  }

  function* fetchCarVariantPricing({ payload: { variantId } }) {
    try {
      const response = yield call(getCarVariantPricingList, variantId)
      yield put(getCarVariantPricingSuccess(response.data.carVariantPricingList))
    } catch (error) {
      yield put(getCarVariantPricingFail(error))
      showToastError('Sorry! Failed to Fetch Variant Pricing, plese try again', 'Error');
    }
  }

  function* deleteCarVariantPricing({ payload: { variantId } }) {
    try {
      const response = yield call(deleteCarVariantPricingList, variantId)
      yield put(deleteCarVariantPricingSuccess())
      showToastSuccess("Variant pricing deleted successfully", "SUCCESS");
    } catch (error) {
      yield put(deleteCarVariantPricingFail(error))
      showToastError('Vsriant Pricing Failed to delete, plese try again', 'Error');
    }
  }

  // Paginated Car Variants Sagas
  function* fetchCarVariantsPaginated({ payload: { pageNum, numProds } }) {
    try {
      const response = yield call(getCarVariantsListPaginated, pageNum, numProds)
      const carVariants = response.data.carVariantList || [];
      const pagination = response.data.pagination || {};
      
      // Extract pagination metadata
      const paginationData = {
        currentPage: pagination.currentPage || pageNum,
        totalPages: pagination.totalPages || 1,
        totalRecords: pagination.totalRecords || 0,
        recordsPerPage: pagination.recordsPerPage || numProds,
        hasNextPage: pagination.hasNextPage || false,
        hasPrevPage: pagination.hasPrevPage || false,
        nextPage: pagination.nextPage || null,
        prevPage: pagination.prevPage || null,
        recordsOnCurrentPage: pagination.recordsOnCurrentPage || carVariants.length
      };
      
      yield put(getCarVariantsPaginatedSuccess(carVariants, paginationData))
    } catch (error) {
      yield put(getCarVariantsPaginatedFail(error))
      showToastError('Sorry! Failed to Fetch Variants, please try again', 'Error');
    }
  }

  function* loadMoreCarVariants({ payload: { pageNum, numProds } }) {
    try {
      const response = yield call(getCarVariantsListPaginated, pageNum, numProds)
      const carVariants = response.data.carVariantList || [];
      const pagination = response.data.pagination || {};
      
      // Extract pagination metadata
      const paginationData = {
        currentPage: pagination.currentPage || pageNum,
        totalPages: pagination.totalPages || 1,
        totalRecords: pagination.totalRecords || 0,
        recordsPerPage: pagination.recordsPerPage || numProds,
        hasNextPage: pagination.hasNextPage || false,
        hasPrevPage: pagination.hasPrevPage || false,
        nextPage: pagination.nextPage || null,
        prevPage: pagination.prevPage || null,
        recordsOnCurrentPage: pagination.recordsOnCurrentPage || carVariants.length
      };
      
      yield put(loadMoreCarVariantsSuccess(carVariants, paginationData))
    } catch (error) {
      yield put(loadMoreCarVariantsFail(error))
      showToastError('Sorry! Failed to Load More Variants, please try again', 'Error');
    }
  }

  // ✅ NEW: Search Car Variants with filters (paginated)
  function* onSearchCarVariants({ payload: filters }) {
    try {
      const response = yield call(searchCarVariantsApi, filters)
      const carVariants = response.data.carVariantList || [];
      const pagination = response.data.pagination || {};
      
      const paginationData = {
        currentPage: pagination.currentPage || filters.pageNum || 1,
        totalPages: pagination.totalPages || 1,
        totalRecords: pagination.totalRecords || 0,
        recordsPerPage: pagination.recordsPerPage || filters.numProds || 50,
        hasNextPage: pagination.hasNextPage || false,
        hasPrevPage: pagination.hasPrevPage || false,
        nextPage: pagination.nextPage || null,
        prevPage: pagination.prevPage || null,
        recordsOnCurrentPage: pagination.recordsOnCurrentPage || carVariants.length
      };
      
      yield put(searchCarVariantsSuccess(carVariants, paginationData))
    } catch (error) {
      yield put(searchCarVariantsFail(error))
      showToastError('Sorry! Search failed, please try again', 'Error');
    }
  }

  // ✅ NEW: Search Car Variants without pagination (get all)
  function* onSearchCarVariantsAll({ payload: filters }) {
    try {
      const response = yield call(searchCarVariantsAllApi, filters)
      const carVariants = response.data.carVariantList || [];
      yield put(searchCarVariantsAllSuccess(carVariants))
    } catch (error) {
      yield put(searchCarVariantsAllFail(error))
      showToastError('Sorry! Search failed, please try again', 'Error');
    }
  }
 
function* carVariantSaga() {
  yield takeEvery(GET_CAR_VARIANTS, fetchCarVariants);
  yield takeEvery(GET_CAR_VARIANTS_PAGINATED, fetchCarVariantsPaginated);
  yield takeEvery(LOAD_MORE_CAR_VARIANTS, loadMoreCarVariants);
  yield takeEvery(ADD_NEW_CAR_VARIANT, onAddCarVariant);
  yield takeEvery(UPDATE_CAR_VARIANT, onUpdateCarVariant);
  yield takeEvery(DELETE_CAR_VARIANT, onDeleteCarVariant);
  yield takeEvery(DELETE_ALL_CAR_VARIANT, onDeleteAllCarVariant);
  yield takeEvery(ADD_ALL_VARIANT_PRICING, onAddAllVariantPricing);
  yield takeEvery(GET_CAR_VARIANT_PRICING, fetchCarVariantPricing);
  yield takeEvery(DELETE_CAR_VARIANT_PRICING, deleteCarVariantPricing);
  // ✅ NEW: Search actions
  yield takeEvery(SEARCH_CAR_VARIANTS, onSearchCarVariants);
  yield takeEvery(SEARCH_CAR_VARIANTS_ALL, onSearchCarVariantsAll);
}

export default carVariantSaga;
